export default __webpack_public_path__ + "static/media/lupa-positive.ecbf92ae.svg";